/**
 * OOO Results LP — interactive behaviours
 *
 * 1. Bundle option-selector tabs  ([data-ooo-bundle-options])
 * 2. FAQ accordion — native <details> enhanced with keyboard + sign animation
 *    (the CSS +/− sign is purely declarative; no extra JS needed for the
 *    open/close state — only needed for graceful keyboard focus management)
 * 3. Reveal scroll animation is handled by the global ooo-motion.js;
 *    this script intentionally does NOT duplicate it.
 */

(function () {
  'use strict';

  /* ── Bundle option selector ───────────────────────────────── */
  document.querySelectorAll('[data-ooo-bundle-options]').forEach(function (group) {
    var opts = group.querySelectorAll('.ooo-res-opt');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
      });
    });
  });

  /* ── FAQ keyboard accessibility ───────────────────────────── */
  // <details>/<summary> handles click natively; add keyboard enter/space on
  // summary elements for older Safari + ensure only one open at a time option
  // (currently NOT enforced — multiple can be open simultaneously, matching
  // the source behavior where first item starts open).
  document.querySelectorAll('.ooo-res-faq__summary').forEach(function (summary) {
    summary.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        summary.closest('details').toggleAttribute('open');
      }
    });
  });

})();
